module.exports = __webpack_public_path__ + "static/img/behind-scenes.3295fed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/behind-scenes.jpg
// module id = BLaY
// module chunks = 1